import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import SvgPieChart from './SvgPieChart'
import { sortBy } from 'lodash'
import { secToHour, secToMinute } from '../../../utils/date'

interface Props {
  list: {
    id: number
    name: string | null
    profile_image?: string | null
    color?: string
    cost: number
    time: number
  }[]
  type: string
  graphTitle: string
  headerTitle: string
  chartSize: number
}

const ReportSummaryModule: FC<Props> = (props) => {
  const {
    list,
    type,
    graphTitle,
    headerTitle,
    chartSize,
  } = props

  const MEMBER_COLOR_LIST = [
    "#D95287",
    "#D85251",
    "#D88B52",
    "#D7CC51",
    "#A1D950",
    "#51D853",
    "#52D9BB",
    "#52B1D9",
    "#5372D7",
    "#7252D8",
    "#AC53D8",
    "#D752AA",
  ]

  return (
    <div className="summary_block">
      <div style={{ width: `${chartSize}px`, paddingTop: "10px" }}>
        <SvgPieChart
          list={sortBy(list, "time").reverse().map((v) => ({
            label: v.name || "",
            value: v.time,
            color: type === "member" ? MEMBER_COLOR_LIST[v.id % 12] : v.color || "#666666",
          }))}
          graphTitle={graphTitle}
          chartSize={chartSize}
          displayOuterLabel
        />
      </div>
      <div
        className="ranking_block"
        style={{
          width: `calc(100% - ${chartSize}px)`,
          height: "340px",
        }}
      >
        <div className="ranking_title">
          {headerTitle}
        </div>
        {
          list.reduce((s, w) => s + w.time, 0) ? (
            <div className="ranking_rows">
              {
                sortBy(list, "time").reverse().filter((v) => v.time > 0)
                  .map((v, i) => (
                    <div className="ranking_row" key={`${headerTitle}_ranking_${v.id}`}>
                      <div className="ranking_title_area">
                        <div className="icon_area">
                          {
                            i < 3 ? (
                              <FontAwesomeIcon icon={['fas', 'crown']} />
                            ) : (
                              <>
                                {i + 1}
                              </>
                            )
                          }
                        </div>
                        <div className="text_area">
                          {
                            type === "member" && (
                              <>
                                {
                                  v.profile_image ? (
                                    <img
                                      alt="profile"
                                      src={v.profile_image}
                                      className="icon"
                                    />
                                  ) : (
                                    <img
                                      alt="profile"
                                      src={`/static/images/profile/${(Number(v.id) || 0) % 12}.jpeg`}
                                      className="icon"
                                    />
                                  )
                                }
                              </>
                            )
                          }
                          {v.name}
                        </div>
                      </div>
                      <div className="detail_area">
                        <div>
                          {
                            v.time ? (
                              `${Math.floor(
                                (v.time / list.reduce((s, w) => s + w.time, 0)) * 10000,
                              ) / 100}%`
                            ) : (
                              ""
                            )
                          }
                        </div>
                        <div>
                          (
                          {
                            Number(secToHour(v.time)) > 0
                              ? (
                                <>
                                  <span>
                                    {secToHour(v.time)}
                                  </span>
                                  時間
                                </>
                              )
                              : ""
                          }
                          {
                            Number(secToMinute(v.time)) > 0
                              ? (
                                <>
                                  <span>
                                    {secToMinute(v.time)}
                                  </span>
                                  分
                                </>
                              )
                              : ""
                          }
                          {
                            (v.time) < 60 && (v.time) > 0
                              ? "1分未満"
                              : ""
                          }
                          {
                            (v.time) === 0
                              ? "0分"
                              : ""
                          }
                          )
                        </div>
                      </div>
                    </div>
                  ))
              }
            </div>
          ) : (
            <div className="no_data">
              データがありません
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ReportSummaryModule
